/**
 * DS twin styling for the color group. `SelectColorGroup` owns the swatch chrome;
 * the only externally-rendered bits are the per-swatch red sale dot (kept on its
 * own `areAllColorVariantsOnSale` predicate) and its column wrapper — both shared
 * with the image option.
 */
export { optionColumnClass as colorOptionWrapperClass, redDotClass } from './option-selector-shared.styles'
